import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TableDataHeader } from '@block-explorer/ui';
import { TableRow } from '@make-software/cspr-design';

import {
  PageDataTable,
  TabDataTable,
  useClientPagination,
} from '../../../components';
import AccountNamedKeysListItem from './AccountNamedKeysListItem';
import { useGetAccountRawData } from '../../../hooks/casper-service-hooks';

export interface AccountTransferListProps {
  accountHash: string;
  showTopPagination?: boolean;
}

const AccountNamedKeysList = ({
  accountHash,
  showTopPagination,
}: AccountTransferListProps) => {
  const { t } = useTranslation();

  const {
    data: accountRawData,
    loading: accountRawDataLoading,
    error,
  } = useGetAccountRawData({
    accountHash: accountHash,
  });

  const namedKeys = accountRawData?.Account?.named_keys
    ? accountRawData?.Account?.named_keys
    : null;

  const {
    data: tableData,
    sortingProps: clientSortingProps,
    paginationProps,
  } = useClientPagination({
    paginationStateKey: 'namedKeys',
    arr: namedKeys,
  });

  const TableComponent = showTopPagination ? PageDataTable : TabDataTable;

  return (
    <TableComponent
      loading={accountRawDataLoading}
      data={tableData || []}
      error={error}
      sortingProps={clientSortingProps}
      paginationProps={paginationProps}
      renderDataHeader={() => (
        <TableRow>
          <TableDataHeader fixedWidthRem={21.25}>
            <Trans t={t}>Key</Trans>
          </TableDataHeader>
          <TableDataHeader>
            <Trans t={t}>Value</Trans>
          </TableDataHeader>
        </TableRow>
      )}
      renderPaginatedData={(namedKeys) =>
        namedKeys.map(({ key, name }, idx) => (
          <AccountNamedKeysListItem key={idx} keyName={key} keyValue={name} />
        ))
      }
    />
  );
};

export default AccountNamedKeysList;
